<script setup lang="ts">
const Icon = useIcon();
import { DocumentDetailIcon } from 'assets/data/icons';

interface IBindings {
  'fill-rule': string;
  'clip-rule': string;
}

const bindings: IBindings = {
  'fill-rule': 'evenodd',
  'clip-rule': 'evenodd',
};
</script>
<template>
  <Icon
    :path="DocumentDetailIcon"
    class="w-8"
    :bindings="bindings"
    :filled="true"
    :size="16"
  />
</template>
